import React, { useState } from 'react';
import MainLayout from './components/layout/MainLayout';
import HomeDashboard from './components/home/HomeDashboard';
import LoginPage from './components/auth/LoginPage';
import { useAuth } from './hooks/useAuth';
import VideoConverter from './components/tools/VideoConverter';
import YouTubeDownloader from './components/tools/YouTubeDownloader';
import InstagramDownloader from './components/tools/InstagramDownloader';
import AudioTools from './components/tools/AudioTools';
import QRCodeTools from './components/tools/QRCodeTools';
import InstagramAudit from './components/tools/InstagramAudit';
import InstagramComparison from './components/tools/InstagramComparison';
import AIBlogWriter from './components/tools/AIBlogWriter';
import AICaptionGenerator from './components/tools/AICaptionGenerator';
import AIProductDescription from './components/tools/AIProductDescription';
import AIContentIdeas from './components/tools/AIContentIdeas';
import WebIntelligence from './components/tools/WebIntelligence';
import AITranscribe from './components/tools/AITranscribe';
import VideoSubtitles from './components/tools/VideoSubtitles';
import WebsiteReport from './components/tools/WebsiteReport';
import UsageReport from './components/tools/UsageReport';
import { Tool } from './components/layout/Sidebar';
import './index.css';

type NonHomeTool = Exclude<Tool, 'home'>;

const TOOL_MAP: Record<NonHomeTool, React.ReactNode> = {
  video:                  <VideoConverter />,
  youtube:                <YouTubeDownloader />,
  instagram:              <InstagramDownloader />,
  'audio-pro':            <AudioTools />,
  'qr-studio':            <QRCodeTools />,
  'ig-audit':             <InstagramAudit />,
  'ig-compare':           <InstagramComparison />,
  'ai-blog':              <AIBlogWriter />,
  'ai-captions':          <AICaptionGenerator />,
  'ai-product':           <AIProductDescription />,
  'ai-ideas':             <AIContentIdeas />,
  'web-intel':            <WebIntelligence />,
  'ai-transcribe':        <AITranscribe />,
  'video-subtitles':      <VideoSubtitles />,
  'website-report':       <WebsiteReport />,
  'usage-report':         <UsageReport />,
  'dev-tools':            <div />,
};

function App() {
  const [activeTool, setActiveTool] = useState<Tool>('home');
  const { user, loading, login, logout } = useAuth();

  if (loading) {
    return (
      <div
        className="fixed inset-0 flex items-center justify-center"
        style={{ background: 'linear-gradient(135deg, #0f111a 0%, #0d1520 50%, #0a1018 100%)' }}
      >
        <svg
          className="animate-spin h-10 w-10"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-label="Loading"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="#54c4b6"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="#54c4b6"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLogin={login} />;
  }

  return (
    <MainLayout activeTool={activeTool} onSelectTool={setActiveTool} user={user} onLogout={logout}>
      {activeTool === 'home'
        ? <HomeDashboard onSelectTool={setActiveTool} />
        : TOOL_MAP[activeTool as NonHomeTool]}
    </MainLayout>
  );
}

export default App;
